import { toDate } from "../events/dateUtils";

export const formatGiftDate = (value) => {
  const date = toDate(value);
  if (!date) return { day: "", month: "" };

  const day = String(date.getDate()).padStart(2, "0");
  const month = date
    .toLocaleString("es-AR", { month: "short" })
    .replace(".", "")
    .toUpperCase();
  return { day, month };
};
